export type MaxWidthContainerProps = React.PropsWithChildren<{
  width?: number;
  centered?: boolean;
  style?: Record<string, unknown>;
}>;

const MaxWidthContainer: React.FC<MaxWidthContainerProps> = ({
  width,
  children,
  centered,
  style,
}) => {
  if (centered) {
    style = { ...style, margin: "0 auto" };
  }
  return <div style={{ width: "100%", ...style }}>{children}</div>;
};
export default MaxWidthContainer;
